export const Range = (min, max, value) => {
  return value >= min && value < max;
};

export const toRadians = (degrees) => {
  return degrees * (Math.PI / 180);
};

export const toDegrees = (radians) => {
  return radians * (180 / Math.PI);
};

// Ensures that the provided value is a finite number, returning null if it is not
export const toFiniteNumber = (value) => {
  const isEmptyString = typeof value === 'string' && value.trim() === '';

  if (value === null || value === undefined || typeof value === 'boolean' || isEmptyString) {
    return null;
  }

  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

// Ensures that the provided value is always within the bounds of min and max
export const getBoundedValue = (value, min, max) => Math.min(Math.max(value, min), max);
